import { customBaseQuery } from '@/lib/baseQuery';
import { ApiResponse } from '@/shared/types';
import { createApi } from '@reduxjs/toolkit/query/react';

export interface CosRecord {
  id: string;
  version: number;
  createdAt: string;
  updatedAt: string;
  vendorAgentEmail: string | null;
  vendorAgentCompanyName: string | null;
  vendorAgentContactName: string | null;
  purchaserFullName: string | null;
  purchaserEmail: string | null;
  stateOfPurchase: string | null;
  buyersAgentName: string | null;
  buyersAgentEmail: string | null;
  purchaserRepresentativeName: string | null;
  purchaserRepresentativeEmail: string | null;
  purchaserRepresentativeCompany: string | null;
}

export const cosApi = createApi({
  reducerPath: 'cosApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getCosExtractedList: builder.query<ApiResponse<CosRecord[]>, void>({
      query: () => '/cos-extraction',
    }),
  }),
});

export const { useGetCosExtractedListQuery } = cosApi;
